import Content from '@/view/women-word-cup-player-comment/china-team/views/Content.vue'

import { RouteRecordRaw, RouterView } from 'vue-router'

export default {
    name: 'women-world-cup-player-comment',
    // path: '/women-world-cup-player-comment',
    // redirect: '/women-world-cup-player-comment/home',
    path: '/',
    redirect: '/home',
    component: RouterView,

    children: [
        {
            name: 'womenWorldCupPlayerCommentHome',
            path: 'home',
            component: () => import('@/view/women-word-cup-player-comment/index.vue'),
        },
        {
            name: 'women-china-team',
            path: 'women-china-team',
            component: () => import('@/view/women-word-cup-player-comment/china-team/views/Index.vue'),
        },
        {
            name: 'women-china-content',
            path: 'women-china-content',
            component: () => import('@/view/women-word-cup-player-comment/china-team/views/Content.vue'),
        },
        {
            name: 'women-nigeria-team',
            path: 'women-nigeria-team',
            component: () => import('@/view/women-word-cup-player-comment/nigeria-team/views/Index.vue'),
        },
        {
            name: 'women-nigeria-content',
            path: 'women-nigeria-content',
            component: () => import('@/view/women-word-cup-player-comment/nigeria-team/views/Content.vue'),
        },

        {
            name: 'women-mali-team',
            path: 'women-mali-team',
            component: () => import('@/view/women-word-cup-player-comment/mali-team/views/Index.vue'),
        },
        {
            name: 'women-mali-content',
            path: 'women-mali-content',
            component: () => import('@/view/women-word-cup-player-comment/mali-team/views/Content.vue'),
        },
        {
            name: 'women-french-team',
            path: 'women-french-team',
            component: () => import('@/view/women-word-cup-player-comment/french-team/views/Index.vue'),
        },
        {
            name: 'women-french-content',
            path: 'women-french-content',
            component: () => import('@/view/women-word-cup-player-comment/french-team/views/Content.vue'),
        },
    ],
} as RouteRecordRaw
